import { inject } from '@angular/core';
import { CanActivateFn, CanActivateChildFn, Router } from '@angular/router';

function hasSession(): boolean {
  // Same storage keys your interceptor already uses
  return !!sessionStorage.getItem('idToken') && !!sessionStorage.getItem('refreshToken');
}

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (hasSession()) {
    return true;
  }

  router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  return false;
};